import { Stack } from 'expo-router';
import React from 'react';

import { AiThreadDetailPage } from '../../../../llm-service/components/AiThreadDetailPage';

export default function AiThreadDetailRoute() {
    return (
        <>
            <Stack.Screen
                options={{
                    title: 'AI Thread Details',
                }}
            />
            <AiThreadDetailPage />
        </>
    );
}
